import { IModal } from './modalIndex';
import i18n from '@src/app/localization/i18n';

export default {
    error: {
        code: 'error',
        title: 'error'
    },
    login: {
        code: 'login',
        title: 'login'
    },
    forgotPassword: {
        code: 'forgotPassword',
        title: 'forgot password',
        containerClass: 'forgot_password_modal',
    },
    depositResponse: {
        code: 'depositResponse',
        title: 'make a deposit',
        containerClass: 'deposit_modal',
    },
    withdrawalIntro: {
        title: 'withdrawal requirements',
        code: 'withdrawalIntro',
    },
    withdrawalBonusesThatCanExpire: {
        title: 'By making this withdrawal, the active bonus on the account and the related winnings will be canceled',
        code: 'withdrawalBonusesThatCanExpire',
    },
    withdrawalOnlineResponse: {
        code: 'withdrawalOnlineResponse',
        containerClass: 'withdrawal_modal',
    },
    withdrawalShopResponse: {
        code: 'withdrawalShopResponse',
        containerClass: 'withdrawal_modal',
    },
    withdrawalError: {
        title: 'withdrawal error',
        code: 'withdrawalError',
        containerClass: 'withdrawal-error_modal',
    },
    idCardVerificationIntro: {
        title: 'identity document verification',
        code: 'idCardVerificationIntro',
        containerClass: 'card-verification-intro_modal',
    },
    idCardVerification: {
        title: 'identity document verification',
        code: 'idCardVerification',
        containerClass: 'card-verification_modal',
    },
    idCardVerificationApproved: {
        title: 'identity document confirm',
        code: 'idCardVerificationApproved',
        containerClass: 'card-verification_confirm_modal',
    },
    transactionHistory: {
        code: 'transactionHistory',
        containerClass: 'history_modal',
    },
    singleTicket: {
        code: 'singleTicket',
        isIndependent: true,
    },
    betSlipPreview: {
        code: 'betSlipPreview',
        isIndependent: true,
    },
    welcomeBonusIntro: {
        code: 'welcomeBonusIntro',
        title: 'welcome bonus',
        containerClass: 'welcome_bonus_modal',
    },
    welcomeBonus: {
        code: 'welcomeBonus',
        title: 'welcome bonus',
        containerClass: 'welcome_bonus_modal',
    },
    message: {
        code: 'message',
        title: '',
        containerClass: 'message_modal',
    },
    smsValidation: {
        code: 'smsValidation',
        title: 'phone number validation',
        containerClass: 'sms_validation_modal',
    },
    chooseGdpr: {
        code: 'chooseGdpr',
        title: 'Choose GDPR',
        containerClass: 'gdpr_modal',
    },
    sessionDuration: {
        code: 'sessionDuration',
        title: 'session duration',
    },
    gameUnavailable: {
        code: 'gameUnavailable',
        title: 'game currently unavailable',
    },
    ticketSubmitRetry: {
        code: 'ticketSubmitRetry',
        title: 'submit failed',
    },
    maintenance: {
        code: 'maintenance',
        title: 'currently under maintenance',
    },
    ticketNotFound: {
        code: 'ticketNotFound',
        title: 'ticket not found',
    },
    smsLimitReached: {
        code: 'smsLimitReached',
        title: 'sms limit reached'
    },
    completeRegistration: {
        code: 'completeRegistration',
        title: 'Complete registration'
    },
    lottoSystems: {
        code: 'lottoSystems',
        title: 'Sisteme de loto',
    },
    numberInput: {
        code: 'numberInput',
        title: i18n.t('enterNumber'),
    },
    cancelTicket: {
        code: 'cancelTicket',
        title: i18n.t('cancel ticket'),
    },
    payoutTicket: {
        code: 'payoutTicket',
        title: i18n.t('payout ticket'),
    },
    sportSystems: {
        code: 'sportSystems',
        title: i18n.t('systems'),
    },
    dateTimeInput: {
        code: 'dateTimeInput',
        title: 'Selectați data',
    }
} as Record<string, IModal>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/shared/modal/modals.ts